import { DiscountItemDataDto } from "./DiscountItemDto";
import { DiscountItemDataModel } from "./DiscountItemModel";

export const transformDiscountItemDtoToModel = (
  dto: DiscountItemDataDto
): DiscountItemDataModel => dto;
